export function checkBlockVisibility(
  el: HTMLDivElement,
  winHeight: number = window.innerHeight / 3
) {
  const rect = el.getBoundingClientRect();
  const elTop = rect.top;
  const elBottom = rect.bottom;

  // Completely visible elements return true
  // Or partially visible elements return true
  const isVisible =
    (elTop >= 0 && elBottom <= window.innerHeight) ||
    (elTop < winHeight && elBottom >= 0);
  return isVisible;
}

export const checkEachBlockVisibility = () => {
  for (const block of document.querySelectorAll<HTMLDivElement>(
    ".check-visibility"
  )) {
    if (!block.classList.contains("is-visible")) {
      const flag =
        checkBlockVisibility(block) || block.classList.contains("is-visible");
      if (flag) {
        block.classList.add("is-visible");
      }
    }
  }
};

export const forceEachBlockVisibility = () => {
  for (const block of document.querySelectorAll<HTMLDivElement>(
    ".check-visibility"
  )) {
    block.classList.add("is-visible");
  }
};

window.addEventListener("load", () => {
  checkEachBlockVisibility();

  if (window.matchMedia("print").matches == true) {
    forceEachBlockVisibility();
  }
});

window.addEventListener("resize", () => {
  checkEachBlockVisibility();
});

window.addEventListener("scroll", () => {
  checkEachBlockVisibility();
});

window.addEventListener("beforeprint", () => {
  forceEachBlockVisibility();
});
